// extracted by mini-css-extract-plugin
export var externalLink = "_79-0";
export var internalLinkLabel = "_79-1";